/** @format */

const template = `
<div class="row">
  <div class="col-6 course-unit-search">
    <ng-form name="courseUnitSearchForm" ng-model-options="::{ debounce: 700 }">
      <div class="form-group">
        <label for="courseUnitSearchInput" ng-class="{'required':ctrl.required}" translate
          >SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.SELECT_COURSE_UNIT</label
        >
        <input
          id="courseUnitSearchInput"
          autocomplete="off"
          type="text"
          class="form-control input-lg"
          ng-model="ctrl.searchText"
          placeholder="{{::'SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.SEARCH_COURSE_UNIT_PLACEHOLDER'|translate}}" />
        <sis-icon icon="search" class="search-with-svg-icon sis-mt-md"></sis-icon>
      </div>
    </ng-form>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="form-group course-unit-list">
      <div class="list-group form-control">
        <div class="list-group-item guidance" ng-if="ctrl.loadingCourseUnits==true" translate
          >SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.LOADING_COURSE_UNITS</div
        >

        <div
          class="list-group-item guidance"
          ng-if="ctrl.isValidSearch==true && ctrl.loadingCourseUnits==false && ctrl.searchResults.totalCount==0 && !ctrl.searchStringIsTooLong"
          translate="SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.NO_COURSE_UNITS"></div>

        <div
          class="list-group-item guidance"
          ng-if="ctrl.isValidSearch==false"
          translate="SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.INVALID_SEARCH_TEXT"></div>

        <div class="list-group-item guidance" ng-if="ctrl.searchStringIsTooLong" translate="INPUT_ERRORS.SEARCH_QUERY_TEXT_TOO_LONG"></div>

        <!-- if assessmentItems.length === 0 then disable group-item -->
        <button
          type="button"
          class="list-group-item link-button"
          data-cy="course-unit-search-result"
          ng-class="{active:ctrl.selectedCourseUnit.id==result.id && ctrl.hasAssessmentItems(result.id), disable:!ctrl.hasAssessmentItems(result.id)}"
          ng-repeat="result in ctrl.searchResults.results"
          ng-click="ctrl.selectCourseUnit(result)">
          <span>{{:: (result.code ? result.code + ', ' : '') + result.name}}</span> <span>({{:: result.credits|creditRange}}</span>
          <span translate>STUDIES.COURSE_UNITS_COMPLETION_METHODS.MODAL.CREDITS_SHORT</span>)
        </button>

        <div
          class="list-group-item guidance"
          ng-if="ctrl.searchResults.hasMore==true"
          translate-value-total="{{ctrl.searchResults.totalCount}}"
          translate-value-limit="{{ctrl.searchResults.results.length}}"
          translate
          >SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.HAS_MORE_RESULTS</div
        >
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="to-bottom">
      <label translate>SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.SELECT_ASSESSMENT_ITEM</label>
    </div>
    <div class="form-group assessment-item-list">
      <div class="list-group form-control">
        <div class="list-group-item guidance" ng-if="ctrl.loadingAssessmentItems" translate
          >SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.LOADING_ASSESSMENT_ITEMS</div
        >
        <div class="list-group-item guidance" ng-if="ctrl.loadingAssessmentItems == false && ctrl.assessmentItems.length == 0" translate
          >SIS_COMPONENTS.ASSESSMENT_ITEM.ASSESSMENT_ITEM_SELECTOR.NO_ASSESSMENT_ITEMS</div
        >

        <button
          type="button"
          class="list-group-item link-button"
          data-cy="assessment-item-search-result"
          ng-repeat="assessmentItem in ctrl.assessmentItems"
          title="{{::ctrl.disableReason(assessmentItem) | translate}}"
          ng-if="!ctrl.loadingAssessmentItems"
          ng-class="{active:ctrl.selectedAssessmentItem.id==assessmentItem.id, disable:ctrl.isDisabled(assessmentItem)}"
          ng-click="ctrl.selectAssessmentItem(assessmentItem)">
          {{::assessmentItem.fullName | localizedString}}
          <span ng-if="assessmentItem.credits">{{:: assessmentItem.credits|creditRangeInParentheses}}</span></button
        >
      </div>
    </div>
  </div>
</div>
`;
export default template;
